import debugLogScriptName from '@/debug-log-script-name'

$(function() {
  $('body').on('click', '.sidebar__menu-item--disabled a', function(e) {
    return false
  })
  const $toolbar = $('.toolbar')
  debugLogScriptName($toolbar, 'sidebar.js')
  $toolbar.each(function() {
    var $toolbar = $(this),
      $sidebarButtonListItem = $toolbar.find('.toolbar__sidebar-button'),
      $sidebarButton = $sidebarButtonListItem.find('[data-toggle="sidebar"]'),
      $sidebar = $('.sidebar'),
      $app = $('.app')

    if ($sidebar.length) {
      $sidebarButtonListItem.addClass('active')
    }

    $sidebarButton.on('click', function(e) {
      $sidebarButton.toggleClass('active')
      $app.toggleClass('app--sidebar-retracted')

      $.ajax({
        method: 'GET',
        url: $(this).attr('data-url'),
        dataType: 'json',
      }).done(function(data) {})

      e.preventDefault()
    })
  })
})
